import {
  AppSignUpModalVariant,
  isFaireDirectVariant,
} from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useSettingFaireDirectSignupModalRefresh } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectSignupModalRefresh";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface IProps {
  modalVariant: AppSignUpModalVariant;
  align?: "left" | "center";
}

export const Title: React.FC<IProps> = ({ modalVariant, align }) => {
  const settingFaireDirectSignupModalRefresh =
    useSettingFaireDirectSignupModalRefresh();

  return (
    <Typography
      variant={
        isFaireDirectVariant(modalVariant) &&
        !settingFaireDirectSignupModalRefresh
          ? {
              mobileAndAbove: "pageHeaderSerifRegular",
              tabletAndAbove: "displaySSerifRegular",
            }
          : "displaySSerifRegular"
      }
      align={align ?? "center"}
    >
      <TitleText modalVariant={modalVariant} />
    </Typography>
  );
};

const TitleText: React.FC<{ modalVariant: AppSignUpModalVariant }> = ({
  modalVariant,
}) => {
  const { faireDirectBrand } = useFaireDirectBrand();
  const brandName = faireDirectBrand?.name;
  const settingFaireDirectSignupModalRefresh =
    useSettingFaireDirectSignupModalRefresh();

  if (modalVariant === AppSignUpModalVariant.FAIRE_DIRECT) {
    if (settingFaireDirectSignupModalRefresh) {
      return brandName ? (
        <StrictLocalMsg
          defaultMessage="Buy {brandCompanyName}, risk‑free"
          description={{
            text: "Title on signup modal encouraging users to sign up in order to buy products from a certain brand. brandCompanyName is the name of the brand that the user is viewing.",
            img: "https://cdn.faire.com/fastly/a8758a8ee20614d4e3c9db463b46dabd4c6cea0912426dd428534b42489be49a.png",
          }}
          values={{
            brandCompanyName: brandName,
          }}
        />
      ) : (
        <StrictLocalMsg
          defaultMessage="Buy from this brand, risk‑free"
          description={{
            text: "Title on signup modal encouraging users to sign up in order to buy products from the brand currently being viewed.",
            img: "https://cdn.faire.com/fastly/3ea07572521c4f7618469060b324b8874b56c8d2fe9e00489ff5f6b00abc5100.png",
          }}
        />
      );
    } else {
      return (
        <StrictLocalMsg
          defaultMessage="Shop {brandName} online"
          description={{
            text: "Title to sign up modal, leveraging some brand name",
          }}
          values={DEPRECATED_backwardsCompatibleValues({ brandName })}
        />
      );
    }
  }

  return (
    <StrictLocalMsg
      defaultMessage="Unlock wholesale pricing"
      description={{
        text: "Our main sign up modal title",
        img: "https://cdn.faire.com/fastly/d4039290caa4b4b1195bac7d196759088d8040225fc98a0c9aa75c3d88a750d5.png",
      }}
    />
  );
};
